module.exports = __webpack_public_path__ + "img/gzh.c443ac26.png";